import { Box, Popover } from "@material-ui/core"
import { useMemo, useState } from "react"
import type { MouseEvent, ReactElement } from "react"

import "./color-picker.style.scss"

export interface IColorPickerProps {
  color: string
  onChange?: (color: string) => void
}

export function ColorPicker(props: IColorPickerProps): ReactElement {
  const { color, onChange } = props
  const [anchorElement, setAnchorElement] = useState<HTMLDivElement | undefined>(undefined)

  const isColorWhite: boolean = useMemo<boolean>(() => {
    return color.toLowerCase() === "#ffffff" || color.toLowerCase() === "#fff" || color.toLowerCase() === "white"
  }, [color])

  const colors: string[] = [
    "#C4C4C4",
    "#FFE600",
    "#08CF4C",
    "#FFFFFF",
    "#FFAF13",
    "#00E0FF",
    "#777777",
    "#FF0000",
    "#009FE3",
    "#000000",
    "#6D00DB",
    "#0030DB"
  ]

  function togglePicker(event: MouseEvent<HTMLDivElement>): void {
    handleClick(event)
  }

  function setColor(color: string): (event: MouseEvent<HTMLDivElement>) => void {
    return (event: MouseEvent<HTMLDivElement>) => {
      if (!onChange) return
      handleClose()
      onChange(color)
      event.stopPropagation()
    }
  }

  function handleClick(event: MouseEvent<HTMLDivElement>) {
    setAnchorElement(event.currentTarget)
  }

  function handleClose() {
    setAnchorElement(undefined)
  }

  function isOpen(): boolean {
    return Boolean(anchorElement)
  }

  return (
    <>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: TODO fix in another PR */}
      {/* biome-ignore lint/style/useSelfClosingElements: TODO fix in another PR */}
      <div
        style={{
          backgroundColor: color,
          borderColor: `${isColorWhite ? "black" : "transparent"}`
        }}
        className="color-picker-swatch cursor-pointer"
        onClick={togglePicker}
      ></div>
      <Popover
        open={isOpen()}
        anchorEl={anchorElement}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <Box className="color-picker-swatch-palette">
          {colors.map((selectableColor: string, index: number) => (
            <Box
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO fix in another PR
              key={index}
              className={`color-swatch ${selectableColor === color ? "selected" : ""}`}
              style={{ backgroundColor: selectableColor }}
              onClick={setColor(selectableColor)}
            />
          ))}
        </Box>
      </Popover>
    </>
  )
}
